import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { Box, Card, IconButton, Typography } from '@mui/material';
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';

import type { DailyDashboardIssue } from '../../../backendsdk/api';
import { TrackedLink as Link } from '../../../components/TrackedComponents';
import { FleetDriversView } from './Defs';

interface AccidentIssueCardProps {
    item: DailyDashboardIssue;
    cardId: number;
    viewMode: FleetDriversView;
}

const AccidentIssueCard: React.FC<AccidentIssueCardProps> = (props) => {
    const isOdd = props.cardId % 2 == 1;
    const details = props.item.issue_details ?? {};
    const driverName = details.driver_name ?? null;
    const licensePlate = details.license_plate ?? null;
    const fleetIdentifier = licensePlate || 'unknown VIN';
    const driverIdentifier = driverName || 'unknown driver';

    const accidentLink = (
        <>
            <Link id="accident-link" component={RouterLink} to={`/accidents/${details.accident_id}`}>
                accident page
            </Link>
            <IconButton
                component={RouterLink}
                to={`/accidents/${details.accident_id}`}
                target="_blank"
                rel="noopener noreferrer"
                size="small"
                aria-label="Open accident in new tab"
            >
                <OpenInNewIcon sx={{ mb: 0.7, fontSize: 12 }} />
            </IconButton>
        </>
    );
    const issueList = Array.isArray(details.issue) ? details.issue : [];
    const remediationList = Array.isArray(details.remediation) ? details.remediation : [];
    const issueDetails = issueList.map((desc: string) => {
        return desc.replaceAll('<IDENTIFIER>', props.viewMode === 'vehicles' ? fleetIdentifier : driverIdentifier);
    });
    const remediationDetails = remediationList.map((desc: string) => {
        return desc.replaceAll('<IDENTIFIER>', props.viewMode === 'vehicles' ? fleetIdentifier : driverIdentifier);
    });

    return (
        <Card
            sx={{
                my: 1,
                p: 2,
                width: 'clamp(40%, 700px, 80%)',
                backgroundColor: isOdd ? '#e0e0e0' : '#cdcdcd',
                borderRadius: '5px',
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    gap: 1,
                }}
            >
                <Box>
                    <Typography variant="caption" sx={{ color: '#606060', fontSize: '12px' }}>
                        Issue #{props.cardId}
                    </Typography>
                    {issueDetails.map((desc: string, idx: number) => (
                        <Typography variant="subtitle1" key={idx} sx={{ fontSize: '18px' }}>
                            {desc}
                        </Typography>
                    ))}
                </Box>
                <Box>
                    <Typography variant="caption" sx={{ color: '#606060', fontSize: '12px' }}>
                        Remediation
                    </Typography>
                    {remediationDetails.map((desc: string, idx: number) => {
                        const hasAccidentLink = desc.includes('<ACCIDENT_LINK>');
                        const parts = hasAccidentLink ? desc.split('<ACCIDENT_LINK>') : [desc];
                        const content = hasAccidentLink
                            ? parts.flatMap((part, i) => (i < parts.length - 1 ? [part, accidentLink] : [part]))
                            : [desc];
                        return (
                            <Typography variant="subtitle1" key={idx} sx={{ fontSize: '18px' }}>
                                {content.map((node, i) =>
                                    typeof node === 'string' ? node : <React.Fragment key={i}>{node}</React.Fragment>,
                                )}
                            </Typography>
                        );
                    })}
                </Box>
            </Box>
        </Card>
    );
};

export default AccidentIssueCard;
